export const TOOLTIP_MOUSE_LEAVEDELAY = 0.1;
